import React from "react";
import { Helmet } from "react-helmet-async";
import { ORIGIN, canon } from "../seo";

// Open Graph and X (Twitter) tags for link previews. These override the
// site-wide defaults in App.jsx (the deepest Helmet wins per property).
// image: file name of a 1200x630 WebP in public/og, without the extension.
export default function SocialMetaTags({ path, title, description, image }) {
  const imageUrl = `${ORIGIN}/og/${image}.webp`;
  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ResearchPal" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canon(path)} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:type" content="image/webp" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:site" content="@ResearchPal_AI" />
    </Helmet>
  );
}
